import Pager from './Pager';

interface Props {
  from: number;
  to: number;
  total: number;
  page: number;
  pageCount: number;
  onPage: (page: number) => void;
  label?: string;
  className?: string;
  /** Hairline rule above the footer: `card` = Students `.pager` (inside a padded-0 card), `list` = Exam `.pg` (16px above). */
  divider?: 'card' | 'list';
}

const DIVIDER = {
  card: 'mt-2.5 border-t border-hairline px-[22px] pb-[18px] pt-3.5',
  list: 'mt-4 border-t border-hairline pt-4',
} as const;

/** Table footer: "Showing 1–10 of 42" on the left, numbered pager on the right. */
export default function PagedFooter({ from, to, total, page, pageCount, onPage, label, className = '', divider }: Props) {
  if (total === 0) return null;
  return (
    <div className={`flex flex-wrap items-center justify-between gap-3 ${divider ? DIVIDER[divider] : ''} ${className}`}>
      <span className="text-[13px] text-muted">
        Showing <span className="font-mono">{from}–{to}</span> of <span className="font-mono">{total}</span>
      </span>
      <Pager page={page} pageCount={pageCount} onPage={onPage} label={label} />
    </div>
  );
}
